import MetricPins from './MetricPins';

export default MetricPins;
